import type { AdminWebsiteScriptsRequest, WebsiteScriptsConfig } from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

export const getScriptsConfig = async (): Promise<WebsiteScriptsConfig> =>
  (await apiClient.get<WebsiteScriptsConfig>('/website/scripts')).data;

export const updateScriptsConfig = async (
  body: AdminWebsiteScriptsRequest,
): Promise<{ updated: number; keys: string[] }> =>
  (await apiClient.patch<{ updated: number; keys: string[] }>('/admin/website/scripts', body)).data;
